<style scoped lang="scss">
.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.nav.nav-pills {
  margin-bottom: 10px;
}
.nav-item {
  width: 50%;
  text-align: center;
}
</style>
<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">
      Registrierte User / Einnahmen durch Werbung (ID: {{ id }})
    </h4>
    <ul class="nav nav-pills" id="myTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          data-toggle="tab"
          href="#registered"
          role="tab"
          >Registrierte User</a
        >
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#revenue" role="tab"
          >Einnahmen durch Werbung</a
        >
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" id="registered" role="tabpanel">
        <affiliate-registered-user-table
          :id="id"
        ></affiliate-registered-user-table>
      </div>
      <div class="tab-pane fade show" id="revenue" role="tabpanel">
        <affiliate-revenue-table :id="id"></affiliate-revenue-table>
      </div>
    </div>
  </v-modal>
</template>

<script lang="babel">
import AffiliateRevenueTable from "@/components/tables/AffiliateRevenueTable";
import AffiliateRegisteredUserTable from "@/components/tables/AffiliateRegisteredUserTable";
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    AffiliateRevenueTable,
    AffiliateRegisteredUserTable,
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  }
};
</script>
